import LoopIcon from '@mui/icons-material/Loop';
import { Step } from '../../components/Step';
import Grid2 from '@mui/material/Unstable_Grid2';
import { Checkboxes } from 'mui-rff';
import { useFormState } from 'react-final-form';
import { useTranslation } from 'react-i18next';
import { Table } from 'src/shared/components/Table/Table';
import { type DataTableRow, useColumnsV2 } from '../../utils/constants';
import { type IntegrationParamOption } from 'src/shared/api/integrations/common';

export enum COLUMN_FIELD_NAMES {
  GROSS_SALARY = 'grossSalary'
}

export const columnFieldLabel = {
  [COLUMN_FIELD_NAMES.GROSS_SALARY]: 'table.monthly gross remuneration'
};

type Step3Props = {
  customFields: IntegrationParamOption[] | undefined;
};

export const Step3 = ({ customFields }: Step3Props) => {
  const { t } = useTranslation('settings');
  const { values } = useFormState();
  const dataTable: DataTableRow[] = Object.values(COLUMN_FIELD_NAMES).map((fieldName: COLUMN_FIELD_NAMES) => ({
    fieldInPayflow: {
      label: columnFieldLabel[fieldName],
      value: fieldName
    }
  }));
  const columns = useColumnsV2('A3 Innuva', customFields ?? []);

  return (
    <Step
      title={`${t('integrations.step')} 3`}
      subtitle={`${t('If you use custom fields', { softwareName: 'A3 Innuva' })}:`}
      Icon={LoopIcon}
    >
      <>
        <Grid2 xs={12}>
          <Checkboxes
            name="withCustomFields"
            data={{ label: t('use custom fields', { ns: 'settings' }), value: true }}
          />
        </Grid2>

        {values?.withCustomFields && <Table rows={dataTable} columns={columns} />}
      </>
    </Step>
  );
};
